export default __webpack_public_path__ + "static/home3-6c85321e25374871badc7ea90f415c14.png";